import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/api/client";
import { useAuth } from "@/auth/useAuth";
import type { MeResponse } from "@/types";

/**
 * Retorna profile + permissões do usuário corrente.
 * Funciona em dev (X-Dev-User) e prod (Bearer JWT) — useAuth abstrai.
 */
export function useMe() {
  const { isAuthenticated } = useAuth();
  return useQuery({
    queryKey: ["me"],
    enabled: isAuthenticated,
    queryFn: async () => {
      const { data } = await apiClient.get<MeResponse>("/me");
      return data;
    },
    staleTime: 60_000,
  });
}
